// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RmsE","placeholdersHeader":"styles_placeholdersHeader__U9zSr","editorStyle":"styles_editorStyle__l7rVQ","placeholdersBox":"styles_placeholdersBox__3D99z"};